import { FC } from 'react';
import { EsimProvider, EsimV3, SubscriptionV3, UserV3 } from '#types';
import { useSafeState } from '#hooks';
import { formatDate } from '../../services/helpers';
import { SubscriptionToDisplayV3 } from './subscriptionToDisplayV3.component';
interface UserInformationV3Props {
    user: UserV3;
}

export const UserInformationV3: FC<UserInformationV3Props> = ({ user }) => {

    const [expandedEsim, setExpandedEsim] = useSafeState<string[]>([]);
    const userEsims = [...user.esims].sort((a, b) => {
        const getTimestamp = (esim: EsimV3): number => {
            if (esim?.createdAt) return new Date(esim?.createdAt).getTime();
            if (esim?.subscriptions?.[0]?.createdAt) return new Date(esim.subscriptions[0]?.createdAt)?.getTime();
            return 0;
        };
        return getTimestamp(b) - getTimestamp(a);
    });

    return <div className='main-dashboard-container pd-m mt-s'>
        {
            userEsims?.length === 0 ?
                <div>{user.firstName} {user.lastName} Did not purchase any eSIM yet</div> :
                userEsims?.map(
                    (esim: EsimV3) => {
                        const icon = expandedEsim.includes(esim.iccid) ? '/images/contract.png' : '/images/expand.png';
                        const subscriptionsText = esim.subscriptions.length > 0 ? `${esim.subscriptions.length} subscription(s)` : 'No subscriptions';
                        return <div key={esim.iccid}>
                            <div
                                className="mb-m three-columns-expand-one"
                                style={{ border: '1px solid black', borderRadius: 4, padding: 6 }}
                            >
                                <div className='bold three-rows-expand-one-three'>
                                    <div />
                                    <div className='selectable-text'>
                                        {esim.provider?.name.toUpperCase()} - {esim.iccid} {esim.provider?.name.toUpperCase() === EsimProvider.ORANGE && esim.msisdn && - esim.msisdn} - {esim?.status?.toUpperCase()} - {subscriptionsText} - {formatDate(esim.subscriptions[esim?.subscriptions?.length - 1]?.createdAt as string)}
                                    </div>
                                    <div />
                                </div>
                                <img
                                    className='expand-contract-esim vertical-align ml-m'
                                    src={icon}
                                    alt="expand"
                                    onClick={
                                        () => {
                                            if (expandedEsim.includes(esim.iccid)) {
                                                setExpandedEsim(expandedEsim.filter(iccid => iccid !== esim.iccid));
                                            } else {
                                                setExpandedEsim([...expandedEsim, esim.iccid]);
                                            }
                                        }
                                    }
                                />
                            </div>
                            {
                                expandedEsim.includes(esim.iccid) && esim.subscriptions.length > 0 && (
                                    <div className='mb-m subscription-columns'>
                                        {
                                            esim.subscriptions.map(subscription =>
                                                <SubscriptionToDisplayV3
                                                    key={subscription.nanoID}
                                                    subscription={subscription as SubscriptionV3}
                                                />
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    }
                )
        }
    </div>
}